// src/hooks/useTaskExport.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const TASK_BASE_URL = API_BASE_PATH;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

// Export Single Task as Excel
export const exportSingleTaskExcel = async (taskId: string, token: string | null) => {
  try {
    if (!taskId) {
      toast.warning("No task ID provided to export.");
      return;
    }

    const response = await axios.get(
      `${TASK_BASE_URL}/Task/task/${taskId}/download/Excel/singel`,
      {
        headers: { accept: "application/json",Authorization: `Bearer ${token}`, },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Task_With_History.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Task Excel downloaded successfully");
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    console.error("Export single task Excel failed:", msg);
    toast.error(msg);
  }
};

// Export All Tasks as Excel
export const exportAllTasksExcel = async (token: string | null) => {
  try {
    const response = await axios.get(
      `${TASK_BASE_URL}/Task/task/download/Excel/all`,
      {
        headers: { accept: "application/json",Authorization: `Bearer ${token}`, },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Tasks_With_History.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("All tasks Excel downloaded successfully");
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    console.error("Export all tasks Excel failed:", msg);
    toast.error(msg);
  }
};
